<template>
  <div
    class="app-layout"
    :class="$route.meta.isCentered ? 'is-full-height' : ''"
  >
    <app-header
      :app-title="app.header.title"
      :is-sticky="false"
    >
      <dropdown-nav
        slot="dropdown-nav"
        :nav="dropdown"
      />
    </app-header>
    <main>
      <div class="container">
        <tabs-nav />
        <div
          class="main-content has-tabs min-height-100"
          :class="loading ? 'main-loading' : ''"
        >
          <loading
            :loading="loading"
            :center="true"
            width="50px"
            message=""
          />
          <transition name="loading-page">
            <div class="content">
              <router-view />
            </div>
          </transition>
        </div>
      </div>
    </main>
    <app-footer
      :links="app.footer.links"
    />
  </div>
</template>
<script>
import { AppHeader, AppFooter, DropdownNav } from '@phila/phila-ui';
import TabsNav from '@/components/TabsNav';

export default {
  name: "UserLayout",
  components: {
    AppHeader,
    AppFooter,
    DropdownNav,
    TabsNav,
  },
  data () {
    return {
      dropdown: {
        button: 'User Settings',
        icon: 'fa fa-user-circle',
        links: [
          {
            href: 'edit-user-profile',
            text: "Profile",
          },
          {
            type: 'native',
            href: 'javascript:;',
            text: 'Logout',
            click: () => {
              this.logout();
            },
          },
        ],
      },
    };
  },
  computed: {
    loading () {
      return this.$store.state.loading;
    },
    app () {
      return this.$store.state.app;
    },
  },
  methods: {
    logout() {
      this.$store.commit('login/logOut');
    },
  },
};
</script>
